<template>
  <div>
    <Button @click="handlerClick()">
      <span v-for='(item,index) in renderData' :key='index' :backgroundColor='item.color'>
        {{item.name}}
      </span>
    </Button>
    <Modal v-model="modalStatus" width='650' @on-ok='handlerOk' @on-cancel='handlerCancel' title='选择角色'>
      <div class="content">
       <el-tree highlight-current node-key="id" :expand-on-click-node='false' :check-on-click-node="true"
          show-checkbox ref="role" :data='role' default-expand-all>
        </el-tree>
      </div>
    </Modal>
  </div>
</template>

<script>

  export default {
    props:[
      'defaultVal'
    ],
    data() {
      return {
        modalStatus: false,
        role: [],
        //已选
        selectVal: [],
        //初始值
        startVal:[],
      };
    },
    created() {
      this.handlerSubmit();
    },
    watch: {
      selectVal: {
        handler(newVal) {
          this.$emit('byRoles',newVal);
        },
        deep:true,
        immediate: true
      },
      defaultVal(val){
        if(val && val.length){
          this.selectVal = val.concat();
        }else{
          this.selectVal = [];
        }
      }
    },
    computed: {
      //Button渲染数据
      renderData() {
        if (this.selectVal.length) {
          return this.selectVal.map((item)=>{
            return {
              name:item.label,
              color: '#000'
            }
          })
        } else {
          return [{
            name: '请选择角色',
            color: '#fff'
          }]
        }
      },
    },
    methods: {
      refData(){
        this.handlerSubmit();
      },
      handlerClick() {
        this.modalStatus = true;
        this.$refs.role.setCheckedNodes(this.selectVal);
        //记录初始值
        this.startVal = this.selectVal;
      },
      handlerCancel() {
        this.$refs.role.setCheckedNodes(this.startVal);
      },
      handlerOk() {
        this.selectVal = this.$refs.role.getCheckedNodes(true);
        var defaultVal = this.defaultVal ? this.defaultVal : [];
        var startIds = defaultVal.map((item)=>{
          return item.id
        })
        var endIds = this.selectVal.map((item)=>{
          return item.id
        })
        this.$emit('byRolesAdd',this.$js.newArr(endIds,startIds))
        this.$emit('byRolesDelete',this.$js.newArr(startIds,endIds))
      },
      handlerSubmit(){
        // 获取角色组和角色(因为角色组和角色name字段不一致,故需要处理)
       this.$api.getAllRoles().then((data) => {
          let arr = data.map((item) => {
            return {
              id: item.id,
              label: item.roleGroupName,
              children: item.roleDOS ? item.roleDOS.map((role) => {
                return {
                  id: role.id,
                  label: role.roleName
                }
              }) : []
            }
          })
          /*
          *  业务原因,如果该角色组没有角色，将无法进行选择
          * */
          this.role = arr.filter((item)=>{
            return item.children.length
          })
        })
      }

    },
  }
</script>


<style scoped>
 .content{
   max-height: 400px;
   overflow: auto;
 }
</style>

